import React from 'react';
import Container from '/@/components/container';
import CropMonitoringStepper from '/@/components/crop-monitoring/stepper';

const CropMonitoringStepperMobile = () => {
    return (
        <Container>
            <CropMonitoringStepper />
        </Container>
    );
};

export default CropMonitoringStepperMobile;
